import styles from './Navigation.module.scss';
import home from '../../assets/navigation/home.png';
import homeHit from '../../assets/navigation/homeHit.png';
import pill from '../../assets/navigation/pill.png';
import pillHit from '../../assets/navigation/pillHit.png';
import review from '../../assets/navigation/review.png';
import reviewHit from '../../assets/navigation/reviewHit.png';
import myPage from '../../assets/navigation/myPage.png';
import myPageHit from '../../assets/navigation/myPageHit.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginConfirm, loginConfirmRurl } from '../../common/loginConfirm';
import { useTranslation } from 'react-i18next';
function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  return (
    <div className={`${styles.container} navigation`}>
      <ul>
        <li
          className={location.pathname == '/' ? styles.hit : ''}
          onClick={() => navigate('/')}
        >
          <img src={location.pathname == '/' ? homeHit : home} alt="home" />
          <span>{t('other.1')}</span>
        </li>
        <li
          className={
            location.pathname.includes('productList') ? styles.hit : ''
          }
          onClick={() => navigate('/productList')}
        >
          <img
            src={location.pathname.includes('productList') ? pillHit : pill}
            alt="pill"
          />
          <span>{t('other.2')}</span>
        </li>
        <li
          className={
            location.pathname.substring(0, 7) == '/review' ? styles.hit : ''
          }
          onClick={() => {
            if (!loginConfirmRurl('/review/all')) return;
            navigate('/review/all');
          }}
        >
          <img
            src={
              location.pathname.substring(0, 7) == '/review'
                ? reviewHit
                : review
            }
            alt="review"
          />
          <span>{t('other.3')}</span>
        </li>
        <li
          className={
            location.pathname.substring(0, 7) == '/myPage' ? styles.hit : ''
          }
          onClick={() => {
            if (!loginConfirmRurl('/myPage')) return;
            navigate('/myPage');
          }}
        >
          <img
            src={
              location.pathname.substring(0, 7) == '/myPage'
                ? myPageHit
                : myPage
            }
            alt="myPage"
          />
          <span>{t('other.4')}</span>
        </li>
      </ul>
      <div className={styles.safeArea}></div>
    </div>
  );
}
export default Navigation;
